export default "__VITE_ASSET__Hoal0t9r__"